import React, { useState } from "react";
import BookCover from "#helpers/BookCover";
import BookStatusButton from "#helpers/BookStatusButton";
import Votes from "#helpers/Votes";
import api from "#utils/api";
import { BOOK_STATUS_BG_COLOR } from "#utils/constants";

const RecommendationCard = ({ recommendation, icon }) => {
  const book = recommendation.recommended_book;
  const [userBookData, setUserBookData] = useState(book?.user_book);
  const [recommendationData, setRecommendationData] = useState(recommendation);

  const upvote = (recommendation) => {
    api
      .post(`/recommendations/${recommendation.id}/upvote`)
      .then((data) => {
        setRecommendationData(data);
      })
      .catch((error) => console.error("Error upvoting recommendation:", error));
  };

  const downvote = (recommendation) => {
    api
      .post(`/recommendations/${recommendation.id}/downvote`)
      .then((data) => {
        setRecommendationData(data);
      })
      .catch((error) => console.error("Error downvoting recommendation:", error));
  };

  return (
    <div
      className={`relative flex flex-col flex-none box-border w-fit h-fit p-3 md:p-4 ${
        BOOK_STATUS_BG_COLOR[userBookData?.status || "set-status"]
      } items-center shadow-main rounded-boxy border border-offBlack`}
    >
      <div
        className={`absolute flex justify-center items-center -top-[1px] md:-top-[1px] -right-[8px] md:-right-[6px] w-[33px] h-[30px] md:w-[36px] md:h-[33px] border border-offBlack rounded-default shadow-main ${
          BOOK_STATUS_BG_COLOR[userBookData?.status || "set-status"]
        }`}
      >
        {icon || <BookStatusButton userBook={userBookData} bookId={book.id} setUserBookData={setUserBookData} />}
      </div>
      <div className="w-[62px] h-24 md:w-[104px] md:h-40 cursor-pointer">
        <BookCover book={book} size="w-[62px] h-24 md:w-[104px] md:h-40" showTitle />
      </div>
      <div className="self-center mt-3 md:mt-5">
        <Votes
          key={`${recommendation.id}-votes`}
          userVote={recommendationData.user_vote}
          upvotes={recommendationData.upvotes}
          handleDownvote={() => downvote(recommendationData)}
          handleUpvote={() => upvote(recommendationData)}
        />
      </div>
    </div>
  );
};

export default RecommendationCard;
